var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"variant":"inverted-primary","disabled":_vm.downloading,"pre-icon":"download"},on:{"click":_vm.download}},[_vm._v("\n  Download CSV Template\n")])}
var staticRenderFns = []

export { render, staticRenderFns }